// src/components/Layout.js
import React from 'react';
import Navbar from './Navbar'; // ✅ Your existing Navbar
import Footer from './Footer'; // ⬅️ Import Footer component

const Layout = ({ children }) => {
  return (
    <>
      <Navbar /> {/* ✅ Keep this untouched */}
      <main>{children}</main>
      <Footer /> {/* ✅ Add this */}
    </>
  );
};

export default Layout;
